
/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { title } from "process";

export interface IStageProgressBadge {
    className: 'completed' | 'active' | 'disabled';
    stageName: string;
}
export const StageProgressBadge = (props: { items: IStageProgressBadge[] }) => {
    return (
        <div className={"stepperCenterAlign"}>
        <div className="stepper-container">
            <div className="stepper">
                <ul className="nav nav-tabs" role="tablist">
                    {props.items.map((item, key) =>
                   
                        <li role="presentation" className={item.className} key={key}>
                           <div className="stageDiv">
                            <a className="persistant-disabled"  data-toggle="tab"  role="tab" title={item.stageName}>
                                <span className="round-tab">{key + 1}</span>
                            </a>
                            <p className={`stage-name  ${item.className}`}>{item.stageName}</p>
                            </div> 
                        </li>
                    )}
                </ul>
            </div>
        </div>
        </div>
    )
}